'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import type { ClassValue } from 'clsx';
import type { ReactNode } from 'react';
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context';
import type { TopNavV6Props } from '@src/components/TopNavV6/TopNavV6Props';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
import { TopNavV6MobileCloseHeader } from './TopNavV6MobileCloseHeader';
import { TopNavV6MobileMenu } from './TopNavV6MobileMenu';
import { TopNavV6MobileMiniMenu } from './TopNavV6MobileMiniMenu';
import { TopNavV6MobileThirdLevelMenu } from './TopNavV6MobileThirdLevelMenu';
const asideClassNames = 'fixed inset-y-0 left-0 z-[100] w-full text-white flex flex-col duration-300 transition-all ease-in-out';
const backgroundGradient = 'linear-gradient(-34.46788108107425deg, #ffffff14, #fff0 75.951%), linear-gradient(90deg, #161819 0%, #161819 100%)';
const Panel = t0 => {
  const $ = _c(14);
  const {
    open,
    onClose,
    className,
    content
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TransitionChild as="div" className="fixed inset-0 z-[99] bg-black/50 transition-opacity duration-300 data-closed:opacity-0 data-open:opacity-100" aria-hidden="true" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = cn(asideClassNames, className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backgroundImage: backgroundGradient
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== content || $[5] !== t2) {
    t4 = <TransitionChild><DialogPanel className={t2} style={t3}>{content}</DialogPanel></TransitionChild>;
    $[4] = content;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== open || $[8] !== t4) {
    t5 = <Transition show={open} as="div" className="fixed inset-0">{t1}{t4}</Transition>;
    $[7] = open;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onClose || $[11] !== open || $[12] !== t5) {
    t6 = <Dialog transition={true} className="relative z-[100] transition duration-300 ease-in-out" onClose={onClose} open={open} static={true}>{t5}</Dialog>;
    $[10] = onClose;
    $[11] = open;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export const TopNavV6MobileSlidingPanel = props => {
  const $ = _c(28);
  const {
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    selectedThirdLevelMenu
  } = useTopNavV6();
  const {
    isDesktop
  } = useBreakpoints();
  if (isDesktop) {
    return null;
  }
  let t0;
  if ($[0] !== setIsMobileMenuOpen) {
    t0 = () => setIsMobileMenuOpen(false);
    $[0] = setIsMobileMenuOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!selectedThirdLevelMenu;
  const t2 = !selectedThirdLevelMenu;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = cn("flex h-full flex-col transition-opacity duration-300", {
      "opacity-30": t1,
      "opacity-100": t2
    });
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== setIsMobileMenuOpen) {
    t4 = <TopNavV6MobileCloseHeader onClick={() => setIsMobileMenuOpen(false)} />;
    $[5] = setIsMobileMenuOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props) {
    t5 = <div className="flex-1 overflow-y-auto"><TopNavV6MobileMenu {...props} /></div>;
    $[7] = props;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = !!selectedThirdLevelMenu;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      backgroundImage: backgroundGradient
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== selectedThirdLevelMenu) {
    t9 = selectedThirdLevelMenu && <>{selectedThirdLevelMenu.miniMenu ? <TopNavV6MobileMiniMenu subNavItem={selectedThirdLevelMenu} /> : <TopNavV6MobileThirdLevelMenu subNavItem={selectedThirdLevelMenu} />}</>;
    $[14] = selectedThirdLevelMenu;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <TransitionChild><div className="absolute inset-0 z-10 flex flex-col transition-opacity duration-300 data-closed:opacity-0 data-open:opacity-100" style={t8}>{t9}</div></TransitionChild>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <Transition show={t7} as="div">{t10}</Transition>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t6) {
    t12 = <div className="relative flex h-full flex-col">{t6}{t11}</div>;
    $[21] = t11;
    $[22] = t6;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== isMobileMenuOpen || $[25] !== t0 || $[26] !== t12) {
    t13 = <Panel open={isMobileMenuOpen} onClose={t0} className="translate-x-0 data-closed:-translate-x-full" content={t12} />;
    $[24] = isMobileMenuOpen;
    $[25] = t0;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};